import React from "react";
import MediaResponsive from "react-responsive";
import { useSettings } from "hooks/useStore";

const MediaQuery = ({ children, ...other }) => {
	const { isClient } = useSettings(["isClient"]);

	if (!isClient) return null;

	return (
		<MediaResponsive {...other}>
			{children}
		</MediaResponsive>
	);
};

export default MediaQuery;
